import convertDecimalToPercentValue from '../../../../../Plan/Countries/utils/convertDecimalToPercentValue';

export interface Saturation {
  min?: number | null;
  max?: number | null;
  default?: number | null;
}

const checkIsNull = (value?: number | null) => {
  return value === null;
};

const renderSaturation = (
  heading: string,
  targetGroupSaturation: number,
  saturation: Saturation
) => {
  if (
    checkIsNull(saturation.min) &&
    checkIsNull(saturation.max) &&
    checkIsNull(saturation.default)
  ) {
    return `${heading} (N/A)`;
  }
  return `${heading} (${convertDecimalToPercentValue(
    targetGroupSaturation ?? 0
  )}%)`;
};

export default renderSaturation;
